/**
 * Переключение между версиями интерфейса: текущая на "/" и новый дизайн на "/v2/".
 *
 * Главная тонкость: Telegram передаёт initData в хеше URL мини-аппа
 * (#tgWebAppData=...&tgWebAppVersion=...&tgWebAppPlatform=...&tgWebAppThemeParams=...).
 * Обычный переход на другой путь этот хеш теряет — и следующая страница
 * стартует без initData, то есть показывает "Приложение должно быть запущено в Telegram".
 * Поэтому при переходе хеш переносится с собой. Источники, по убыванию надёжности:
 *   1) живой location.hash;
 *   2) копия, снятая при загрузке страницы (sessionStorage, переживает переход);
 *   3) реконструкция из уже проинициализированного SDK.
 */

const HASH_KEY = "tgWebAppLaunchHash";

const hasLaunchParams = (hash) => typeof hash === "string" && hash.includes("tgWebApp");

/**
 * Снять стартовый хеш Telegram. Вызывать в самом начале точки входа,
 * до рендера, чтобы копия точно была на руках.
 */
export function captureTgLaunchParams() {
  try {
    if (hasLaunchParams(window.location.hash)) {
      sessionStorage.setItem(HASH_KEY, window.location.hash);
    }
  } catch (e) {
    // sessionStorage может быть недоступен — не критично, есть другие источники
  }
}

/** Хеш со стартовыми параметрами Telegram или пустая строка. */
export function getTgLaunchHash() {
  try {
    if (hasLaunchParams(window.location.hash)) return window.location.hash;

    const saved = sessionStorage.getItem(HASH_KEY);
    if (hasLaunchParams(saved)) return saved;
  } catch (e) {
    // идём к реконструкции ниже
  }

  try {
    const wa = window.Telegram && window.Telegram.WebApp;
    if (wa && wa.initData) {
      const params = new URLSearchParams();
      params.set("tgWebAppData", wa.initData);
      params.set("tgWebAppVersion", wa.version || "6.0");
      params.set("tgWebAppPlatform", wa.platform || "unknown");
      params.set("tgWebAppThemeParams", JSON.stringify(wa.themeParams || {}));
      return "#" + params.toString();
    }
  } catch (e) {
    // ничего не поделать — вернём пустую строку
  }

  return "";
}

/** Переход на указанный путь с сохранением query и стартовых параметров Telegram. */
export function goToVersion(path) {
  const search = window.location.search || "";
  window.location.assign(path + search + getTgLaunchHash());
}

/** Новый дизайн. */
export function goToV2() {
  goToVersion("/v2/");
}

/** Текущая (старая) версия. */
export function goToLegacy() {
  goToVersion("/");
}
